<template>
<div class="flex-container" id="contact">

  <div id="generalEnquiryContainer" class="flex-item col-12 flex-container">
    <h3></h3>

    <form id="form" class="flex-item col-12 margin-0" v-on:submit.prevent="submit">
      <div class="flex-item col-12">
        <i class="required">{{translations.allfeilds1}} <span>*</span> {{translations.allfeilds2}}</i>
      </div>



      <div class="flex-item col-12 flex-container radioToggleOptions" id="complaintOptionsContainer">


        <h3 class="flex-item col-12">{{translations.complainenquiry}} <span class="requireditem">*</span></h3>

        <div class="option two">
          <input type="radio" id="Product" name="productOrService" value="Product" v-model="productOrService">
          <label for="Product">{{translations.product}}</label>
        </div>

        <div class="option two">
          <input type="radio" id="Service" name="productOrService" value="Service" v-model="productOrService">
          <label for="Service">{{translations.service}}</label>
        </div>


        <h3 class="flex-item col-12">{{translations.wheredidyoubuy}} <span class="requireditem">*</span></h3>

        <div class="option two">
          <input type="radio" id="online" name="purchaseOptions" value="Online" v-model="purchaseOptions">
          <label for="online">{{translations.online}}</label>
        </div>

        <div class="option two">
          <input type="radio" id="retail" name="purchaseOptions" value="Retail" v-model="purchaseOptions">
          <label for="retail">{{translations.retail}}</label>
        </div>

        <div class="flex-item col-12" v-if="purchaseOptions === 'Online'">
          <label for="orderNumber">{{translations.ordernumber}} <span>*</span></label>
          <input v-model="orderNumber" type="number" required class="form-control" id="orderNumber" placeholder="21686939">
          <small class="form-text text-muted">{{translations.ordernumberhelp}}</small>
        </div>

      </div>


      <div class="flex-item col-12">
        <label for="email">{{translations.email}} <span>*</span></label>
        <input v-model="email" type="email" class="form-control" required id="email" :placeholder="translations.emailplaceholder">
        <small class="form-text text-muted">{{translations.neverShare}} <a href="https://www.regatta.pl/polityka-prywatnosci/" target="_blank">{{translations.neverShareLink}}</a> </small>
      </div>

      <div class="flex-item col-12">
        <label for="fullName">{{translations.fullName}} <span>*</span></label>
        <input v-model="fullName" type="text" required class="form-control" id="fullName" :placeholder="translations.fullNameplaceholder">
      </div>


      <div class="flex-item col-12">
        <label for="comment">
          <div v-if="state === 'generalEnquiry'">{{translations.message}} <span>*</span></div>
        </label>
        <textarea v-model="comment" type="text" required class="form-control" id="comment" :placeholder="translations.message"></textarea>
      </div>

      <div class="flex-item col-12 flex-container" v-if="successMessage === 'yes' " id="successMessage" @click="closeSuccessMessage()">
        <h2>{{translations.thankyou}}</h2>
        <div>{{translations.successmessage1}} {{translations.successmessage2}}</div>
      </div>

      <button type="submit" class="btn btn-primary">

        <div class="spinner-border" role="status" v-if="sendState === 'sending'">
          <span class="sr-only">{{translations.sending}} </span>
        </div>

        <div v-if="sendState != 'sending'">{{translations.submit}}</div>

      </button>
    </form>
  </div>

</div>
</template>

<script>
const axios = require('axios');
import jsonFile from './translations.json'

export default {
  name: 'app',
  mounted: function() {
    this.onPageLoad()
  },
  data() {
    return {
      newItem: '',
      state: '',
      brand: null,
      brandURL: null,

      sendState: 'default',
      fullName: null,
      email: null,
      postCode: null,
      orderNumber: null,
      comment: null,
      purchaseOptions: '',
      productOrService: null,
      token: 0,
      attachmentQty: null,
      successMessage: null,
      translations: "",
    }
  },
  methods: {

    onPageLoad: function() {
      document.getElementsByTagName('html')[0].setAttribute("data-brand", this.$router.currentRoute.params.pathMatch);
      document.getElementsByTagName('html')[0].setAttribute("data-lang", this.$router.currentRoute.query.lang);

      console.log(this.$router.currentRoute)

      this.brand = this.$router.currentRoute.params.pathMatch

      var key = this.$router.currentRoute.query.lang
      var translationsUK = jsonFile.uk
      var translationsFR = jsonFile.fr
      var translationsDE = jsonFile.de
      var translationsPL = jsonFile.pl

      if (key == "uk") {
        this.translations = translationsUK
      }
      if (key == "us") {
        this.translations = translationsUK
      }
      if (key == "eu") {
        this.translations = translationsUK
      }
      if (key == "ie") {
        this.translations = translationsUK
      }
      if (key == "fr") {
        this.translations = translationsFR
      }
      if (key == "de") {
        this.translations = translationsDE
      }
      if (key == "pl") {
        this.translations = translationsPL
      }

    },
    closeSuccessMessage: function() {
      this.successMessage = null
    },
    submit: function() {
      this.sendState = 'sending';

      var params = {
        "request": {
          "subject": "Complaint",
          "comment": {
            "body": this.comment,
          },

          "custom_fields": [{
              "id": "360007768460",
              "value": this.orderNumber
            },
            {
              "id": "360007768860",
              "value": this.purchaseOptions
            },
            {
              "id": "360012510240",
              "value": this.productOrService
            },
            {
              "id": "360007768420",
              "value": this.fullName
            },
          ],
          "tags": [
            this.$router.currentRoute.params.pathMatch + "_" + this.$router.currentRoute.query.lang + '_complaint',
            "complaint_enquiry"
          ],

          "requester": {
            "email": this.email,
            "role": "end-user",
            "name": this.fullName
          },
        }
      }
      console.log(params)
      axios.post('https://regatta.zendesk.com/api/v2/requests.json', params).then(resp => {
        this.fullName = this.email = this.postCode = this.orderNumber = this.productSKU = this.comment = "";
        console.log(resp.status);
        this.sendState = '';
        this.successMessage = "yes"

      }).catch(error => {
        console.log(error)
      });


    }
  }
}



/* Used for when pages use two forms at once. Orginal solution only allows for a single page value */
setInterval(function(){
  /*eslint-disable */
  function sendHeightFooter(eventFooter) {

    var heightValue = document.querySelector("body").offsetHeight;;
    parent.postMessage(JSON.stringify({
      "heightFooter": heightValue
    }), "*");
  }
  if (window.addEventListener) {
    window.addEventListener("load", sendHeightFooter, false);
  } else if (window.attachEvent) {
    window.attachEvent("onload", sendHeightFooter);
  }

  sendHeightFooter();
}, 500);
</script>
